// Small mobile-safe confirmation dialog built on the shared Dialog primitive.
// Used across Prompt 2.2 admin actions (promote / remove alternate).
import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogBody, DialogFooter,
  DialogTitle, DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';

export default function ConfirmDialog({
  open, onOpenChange,
  title, description,
  confirmLabel = 'Confirm',
  cancelLabel  = 'Cancel',
  destructive  = false,
  busy         = false,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !busy) onOpenChange(v); }}>
      <DialogContent data-testid="confirm-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="pr-6">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <DialogBody />
        <DialogFooter>
          <Button
            variant="outline"
            data-testid="confirm-cancel"
            onClick={() => onOpenChange(false)}
            disabled={busy}
          >
            {cancelLabel}
          </Button>
          <Button
            data-testid="confirm-submit"
            onClick={onConfirm}
            disabled={busy}
            className={destructive
              ? 'bg-red-600 text-white hover:bg-red-700'
              : 'bg-[#013523] text-white hover:bg-[#024029]'}
          >
            {busy ? 'Working…' : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
